import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Styles from './styles/Slide.module.css'

export default function Slide(props) {
    return (
        <Stack className={`${Styles.container} ${props.severity === 'warning' ? Styles.warning : props.severity === 'normal' ? Styles.normal : Styles.normal}`} >
            <Typography variant='h6'>{props.title}</Typography>
            <Typography>{props.content}</Typography>
        </Stack>
    )
}